module.exports = __webpack_public_path__ + "img/big3-15.fa9a6cf7.jpg";